import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const ExtendingFooterStyles = StyleSheet.create( {
	overlay: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.5)',
		opacity: 0,
	},
	
	overlayCloseButton: {
		position: 'absolute',
		right: 5,
		top: -16,
		width: 32,
		height: 32,
		backgroundColor: colorList.WHITE.primary,
		borderRadius: 16,
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 250
	},
	
	buttonContainer: {
		width: '100%',
		flex: 1,
		marginTop: 4,
	},
	buttonContainerDesktop: {
		flex: 0,
		flexGrow: 0,
		flexShrink: 0,
		flexBasis: 260,
		width: 260,
		marginTop: 0,
		marginLeft: 16,
	},
	
	container: {
		flex: 0,
		flexDirection: 'column',
	},
	containerDesktop: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	containerExtended: {
		position: 'absolute',
		flex: 1,
		top: 75,
	},
	
	timeslotSingleLeft: {
		flex: 1,
	},
	contentDesktop: {
		flex: 1,
		flexBasis: 0,
		flexShrink: 1,
		minWidth: 0,
		width: 0,
	},
	timeslotSingleRight: {
		width: 50,
		alignItems: 'center',
		justifyContent: 'center',
	},
	timeslotCounter: {
		position: 'absolute',
		right: -2,
		bottom: -2,
		width: 15,
		height: 15,
		borderWidth: 2,
		borderColor: colorList.WHITE.primary,
		backgroundColor: colorList.ORANGE.light,
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 4,
		overflow: 'hidden'
	},
	timeslotCounterText: {
		fontSize: 9,
		color: colorList.BLACK.primary
	},
	
	bookingsContainer: {
		flexDirection: 'row',
		height: 'auto',
		flex: 1,
	},
	bookingsContainerExtended: {
		top: 0,
		width: '100%'
	},
});
